import { render, staticRenderFns } from "./SaleGroups.vue?vue&type=template&id=251a9aae&scoped=true&lang=html&"
import script from "./SaleGroups.vue?vue&type=script&lang=js&"
export * from "./SaleGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251a9aae",
  null
  
)

export default component.exports